import React from 'react';
import { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const ServiceSection = () => {
  useEffect(() => {
    if (typeof window.AOS !== 'undefined') {
      window.AOS.init({
        duration: 1000,
        easing: 'ease-in-out',
        once: true,
        mirror: false
      });
    }
  }, []);

  const services = [
    {
      number: "01",
      title: "Contract Farming Agreements",
      description: "We offer pre-agreed contracts with farmers, ensuring a secure market upon harvest.",
      icon: "bi-flower1"
    },
    {
      number: "02",
      title: "Harvest Purchase Agreements",
      description: "We purchase produce directly from farmers at competitive prices, reducing reliance on intermediaries.",
      icon: "bi-tree"
    },
    {
      number: "03",
      title: "Market Access Facilitation",
      description: "We connect farmers to a broad network of buyers, expanding their market reach.​",
      icon: "bi-gear"
    },
    {
      number: "04",
      title: "Logistics & Aggregation",
      description: "We collect, clean, sort, package, and deliver farm produce to buyers.",
      icon: "bi-scissors"
    },
    {
      number: "05",
      title: "Financial Support",
      description: "We facilitate connections with financial institutions for loans tailored to agricultural needs.",
      icon: "bi-droplet"
    },
    {
      number: "06",
      title: "Capacity Building and Training",
      description: "We conduct regular training sessions on sustainable farming practices, post-harvest handling, and quality control.",
      icon: "bi-basket"
    },
    {
      number: "07",
      title: "Technology Solutions",
      description: "We provide access to digital tools and platforms that enhance farming productivity and market access.",
      icon: "bi-layers"
    },
    {
      number: "08",
      title: "Market Advisory",
      description: "We offer real-time market insights, trends, and expert advice to help farmers make informed decisions.",
      icon: "bi-graph-up"
    }
    
  ];

  return (
    <section id="services" className="services section">
      <div className="container section-title" data-aos="fade-up">
        <h2 className="text-center mb-3">OUR SERVICES</h2>
        <p className="text-center">Practical Solutions for Profitable, Sustainable Farming</p>
      </div>

      <div className="content">
        <div className="container">
          <div className="row g-0">
            {services.map((service, index) => (
              <div key={index} className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="service-item p-4 h-100 d-flex flex-column">
                  <span className="number">{service.number}</span>
                  <div className="service-item-icon mb-3">
                    <i className={`bi ${service.icon} fs-1`}></i>
                  </div>
                  <div className="service-item-content">
                    <h3 className="service-heading h5 mb-3">{service.title}</h3>
                    <p className="mb-0 text-muted">
                      {service.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        .services {
          padding: 80px 0;
          background: #fff;
        }

        .section-title {
          margin-bottom: 60px;
        }

        .service-item {
          position: relative;
          transition: all 0.3s ease;
          border: 1px solid #eee;
        }

        .service-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 5px 15px rgba(255, 215, 0);
        }

        .number {
          position: absolute;
          top: 20px;
          right: 20px;
          font-size: 24px;
          font-weight: bold;
          color: #e4e4e4;
        }

        .service-item-icon {
          color: #4CAF50;
          margin-bottom: 1rem;
        }

        .service-heading {
          color: #333;
          font-weight: 600;
        }

        @media (max-width: 768px) {
          .service-item {
            margin-bottom: 30px;
          }
        }
      `}</style>
    </section>
  );
};

export default ServiceSection;